<template>
  <VueFinalModal
    :class="classes"
    content-class="ui-modal-bottom__content-wrapper"
    @update:model-value="(val) => emit('update:modelValue', val)"
    overlay-transition="vfm-fade"
    content-transition="vfm-slide-down"
    swipe-to-close="down"
  >
    <div class="ui-modal-bottom__header">
      <slot name="header"></slot>
    </div>

    <div class="ui-modal-bottom__content">
      <slot></slot>
    </div>
  </VueFinalModal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { VueFinalModal } from 'vue-final-modal'

const classes = computed(() => ({
  'ui-modal-bottom': true,
}))

const emit = defineEmits<{
  (e: 'update:modelValue', modelValue: boolean): void
}>()
</script>

<style lang="scss">
@import '../styles/config';

.ui-modal-bottom {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.ui-modal-bottom__header {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 3.375rem;
  margin-bottom: 0.75rem;
}

.ui-modal-bottom__content-wrapper {
  position: relative;
  max-width: 100%;
  width: 100%;
  max-height: 90%;
  min-height: 25%;
  background-color: $white;
  border-radius: 0.5rem 0.5rem 0 0;
  box-shadow: 0.125rem 0.625rem 2rem 0 rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.ui-modal-bottom__close {
  position: absolute;
  top: 0;
  right: 1.25rem;
  background-color: $white;
  transform: translate(0, -50%);

  svg {
    width: 1rem !important;
    height: 1rem !important;
  }
}

.ui-modal-bottom--mobile-full-screen {
  @include media-breakpoint-down(md) {
    &.ui-modal-bottom {
      padding: 0;
    }

    .ui-modal-bottom__content {
      width: 100%;
      min-height: 100%;
      padding: 3.75rem 0.75rem 1.25rem;
      border-radius: 0;
    }

    .ui-modal-bottom__close {
      top: 0.75rem;
      right: 0.75rem;
      transform: none;
    }
  }
}
</style>
